import { AsyncRequest } from 'angieslist-app-platform';

export default {
  ...AsyncRequest.createActionKeys('GET_INBOX_PAGE'),
  ...AsyncRequest.createActionKeys('GET_AUTOMATION_MESSAGE'),
  ...AsyncRequest.createActionKeys('SET_AUTOMATION_MESSAGE'),
  ...AsyncRequest.createActionKeys('GET_AUTOMATION_TEMPLATES'),
  ...AsyncRequest.createActionKeys('GET_UNREAD_MESSAGE_COUNT'),
  SET_UNREAD_MESSAGE_COUNT: 'inbox/SET_UNREAD_MESSAGE_COUNT',
  SET_IS_INBOX_ENABLED: 'inbox/SET_IS_INBOX_ENABLED',
  SET_IS_AUTOMATION_ENABLED: 'inbox/SET_IS_AUTOMATION_ENABLED',
  SET_FETCH_UNREAD_COUNT_FROM_CONVERSATION_SERVICE: 'inbox/SET_FETCH_UNREAD_COUNT_FROM_CONVERSATION_SERVICE',
  SET_SHOULD_SHOW_HEADER: 'inbox/SET_SHOULD_SHOW_HEADER',
};



// WEBPACK FOOTER //
// ./src/modules/inbox/common/inboxActionKeys.js